import { createSelector, createSlice } from '@reduxjs/toolkit';

const invoicesSlice = createSlice({
    initialState: {
        isLoading: false,
        error: null,
        manualInvoice: {
            job: null,
            invoice: null,
            trackers: [],
        },
    },
    name: 'invoices',
    reducers: {
        // Manual Invoice Creation
        createManualInvoice: state => {
            state.isLoading = true;
            state.error = null;
        },
        manualInvoiceCreated: (state, { payload }) => {
            state.isLoading = false;
            state.error = null;
            state.manualInvoice = {
                job: payload.job,
                invoice: payload.invoice,
                trackers: payload.trackers || [],
            };
        },
        manualInvoiceCreationFailed: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload?.error || 'Failed to create manual invoice';
        },
        // Reset manual invoice state
        resetManualInvoice: state => {
            state.manualInvoice = {
                job: null,
                invoice: null,
                trackers: [],
            };
            state.error = null;
        },
    },
});

// Selectors
const getSelf = state => state.invoices;

export const getManualInvoice = createSelector(
    getSelf,
    state => state.manualInvoice,
);

export const isInvoiceLoading = createSelector(
    getSelf,
    state => state.isLoading,
);

export const getInvoiceError = createSelector(getSelf, state => state.error);

// Export actions
export const {
    createManualInvoice,
    manualInvoiceCreated,
    manualInvoiceCreationFailed,
    resetManualInvoice,
} = invoicesSlice.actions;

// Export reducer
export default invoicesSlice.reducer;
